/**
 * Background Control Group Utilities
 *
 * Helper functions for generating CSS and working with background attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

// Export all utility functions
export { hasAnyBackgroundValues } from './has-any-background-values';
export { hasBackgroundValues } from './has-background-values';
export { resetBackgroundAttributes } from './reset-background-attributes';
